import React from 'react';
import { DocumentStorageContextProvider } from 'framework/documentStorage';
import useProcessAssetsDocumentService from './useProcessAssetsDocumentService';

const ProcessAssetsDocumentContext = ({ children }: { children: React.ReactNode }) => {
  const actions = useProcessAssetsDocumentService();

  return <DocumentStorageContextProvider value={actions}>{children}</DocumentStorageContextProvider>;
};

export default ProcessAssetsDocumentContext;
